import Image from 'next/image';
import type {SummaryGuide} from 'iq-onboarding/types';
import {guideKey, pickTopGuides} from 'iq-onboarding/utils';

// Cap the rendered guides so the card height roughly matches the questions list.
const MAX_GUIDES = 3;

export function GuidesCard({guides, totalCount}: {guides: SummaryGuide[]; totalCount: number}) {
  const topGuides = pickTopGuides(guides, MAX_GUIDES);

  return (
    <div className='bg-white rounded-2xl p-5 flex flex-col gap-4 h-full'>
      <div>
        <h2 className='text-lg font-bold text-iq-black'>Interview guides</h2>
        <p className='text-sm text-iq-grey-medium'>
          Step-by-step prep tailored to each company and role.
        </p>
      </div>

      <div className='flex items-baseline gap-2'>
        <span data-testid='summary-guides-count' className='text-3xl font-extrabold text-iq-orange'>
          {totalCount.toLocaleString()}
        </span>
        <span className='text-sm font-semibold text-iq-grey-dark'>published guides</span>
      </div>

      <div className='flex flex-col gap-3'>
        {topGuides.map((guide) => (
          <div
            key={guideKey(guide)}
            data-testid='summary-guide-row'
            className='flex items-start gap-3 rounded-lg border border-iq-grey-light p-3'>
            {guide.company_logo ? (
              <Image
                src={guide.company_logo}
                alt={guide.company_name}
                width={40}
                height={40}
                className='rounded-md object-contain bg-white shrink-0'
                unoptimized
              />
            ) : (
              <div className='w-10 h-10 rounded-md bg-iq-grey-lighter shrink-0' />
            )}
            <div className='min-w-0'>
              <h3 className='text-sm font-bold text-iq-black'>{guide.title}</h3>
              {guide.summary && <p className='text-xs text-iq-grey-dark mt-1'>{guide.summary}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
